import { IMAGES } from "@/data/images";

export const PHONE = "085-1307675";
export const PHONE_TEL = "tel:0851307675";
export const EMAIL = "info@beveiligalles.nl";
export const SITE_URL = "https://brandpreventierecycling.nl";

export const NAV_LINKS = [
  { label: "Oplossing", to: "/#oplossing" },
  { label: "Hoe het werkt", to: "/hoe-het-werkt" },
  { label: "Toepassingen", to: "/toepassingen" },
  { label: "Werkwijze", to: "/werkwijze" },
  { label: "Veelgestelde vragen", to: "/veelgestelde-vragen" },
  { label: "Contact", to: "/contact" },
];

export const HERO_BENEFITS = [
  "Automatische thermische bewaking",
  "Instelbare temperatuurzones",
  "Thermisch én zichtbaar camerabeeld",
  "Advies, installatie en service",
];

export const WHY_CARDS = [
  {
    nr: "01",
    title: "Contactloze temperatuurmeting",
    text: "De camera bewaakt oppervlaktetemperaturen en warmtepatronen zonder fysiek contact met het materiaal.",
  },
  {
    nr: "02",
    title: "Instelbare detectiezones",
    text: "Maak afzonderlijke zones voor afvalbunkers, opslagvakken, transportbanden, machines of batterijopslag.",
  },
  {
    nr: "03",
    title: "Vooralarm en alarm",
    text: "Stel verschillende grenswaarden in, zodat een oplopende temperatuur eerst een waarschuwing en daarna een alarm kan veroorzaken.",
  },
  {
    nr: "04",
    title: "Visuele verificatie",
    text: "Bij bi-spectrumcamera's kan het thermische beeld worden gecombineerd met een normaal camerabeeld om de locatie van een mogelijke hotspot sneller te beoordelen.",
  },
];

export const HOW_STEPS = [
  {
    nr: "1",
    title: "Warmtepatronen registreren",
    text: "De thermische sensor registreert infrarode straling en zet temperatuurverschillen om in een thermisch beeld. Hierdoor worden warme en koude gebieden zichtbaar, ook wanneer er weinig of geen zichtbaar licht aanwezig is.",
  },
  {
    nr: "2",
    title: "Risicogebieden instellen",
    text: "Tijdens de configuratie worden specifieke meetgebieden ingesteld, bijvoorbeeld afvalbunkers, opslagvakken, sorteerlijnen, transportbanden, machines, accu- en batterijopslag, laad- en loszones en materiaalhopen op buitenterreinen.",
  },
  {
    nr: "3",
    title: "Grenswaarden bepalen",
    text: "Per zone kunnen temperatuurregels worden ingesteld: maximale temperatuur, vooralarm, hoofdalarm, afwijkende temperatuurstijging, uitsluitingsgebieden en actieve tijdschema's. De beschikbare regels zijn afhankelijk van het gekozen model en de uiteindelijke systeemconfiguratie.",
  },
  {
    nr: "4",
    title: "Alarm activeren",
    text: "Wanneer een ingestelde waarde wordt overschreden, kan het systeem afhankelijk van de configuratie een melding tonen in de videomanagementsoftware, een pushmelding of e-mail versturen, een relais- of alarmuitgang schakelen, een akoestisch of visueel signaal activeren, een controlekamer of externe opvolgingsdienst informeren, of een gekoppeld bedrijfsprotocol starten.",
  },
  {
    nr: "5",
    title: "Verifiëren en handelen",
    text: "Medewerkers kunnen het thermische en normale camerabeeld controleren, de locatie van de hotspot beoordelen en volgens het afgesproken veiligheidsprotocol handelen.",
  },
];

export const SYSTEM_PARTS = [
  {
    title: "Thermische camera",
    icon: "camera",
    items: [
      "Vaste thermische bulletcamera",
      "Bi-spectrumcamera met thermisch en optisch beeld",
      "Thermische PTZ-camera voor grotere terreinen",
      "Meerdere vaste camera's voor afzonderlijke opslagvakken",
      "Vroegtijdige rookdetectie, afhankelijk van model en configuratie",
    ],
    note: "Camera en lens worden per project berekend.",
  },
  {
    title: "Netwerk en infrastructuur",
    icon: "network",
    items: [
      "PoE-netwerk",
      "Glasvezelverbindingen voor grotere afstanden",
      "Industriële netwerkcomponenten",
      "Noodstroom of UPS als optie",
      "Beveiligde externe verbinding",
      "Eventuele mobiele back-upverbinding",
    ],
  },
  {
    title: "Opname en beheer",
    icon: "monitor",
    items: [
      "Hikvision NVR",
      "HikCentral of passende videomanagementsoftware",
      "Lokale controlekamer",
      "Externe beheeromgeving",
      "Mobiele app, wanneer ondersteund en geconfigureerd",
    ],
  },
  {
    title: "Alarmopvolging",
    icon: "bell",
    items: [
      "Interne beveiliging",
      "Bedrijfshulpverlening",
      "Controlekamer",
      "Akoestische of visuele signalering",
      "Alarmrelais of I/O-module",
      "Externe meldkamer als optionele dienst",
      "Bestaande technische systemen, mits technisch toegestaan",
    ],
  },
];

export const APPLICATIONS = [
  {
    id: "afvalbunkers",
    title: "Afvalbunkers",
    text: "Bewaking van grote opslagvakken en bunkers waarin afval of restmaterialen langere tijd worden opgeslagen.",
    image: IMAGES.bunkerOptical,
    alt: "Afvalbunker met opgeslagen restmateriaal in een recyclinginstallatie",
    area: "Afvalbunker",
  },
  {
    id: "papier-karton",
    title: "Opslag van papier en karton",
    text: "Signalering van afwijkende warmteontwikkeling in grote hoeveelheden brandbaar materiaal.",
    image: IMAGES.paper,
    alt: "Balen papier en karton op een recyclingterrein",
    area: "Opslagvak",
    type: "Papier en karton",
  },
  {
    id: "kunststof-rubber",
    title: "Kunststof- en rubberopslag",
    text: "Thermische bewaking van opslagzones, productiegebieden en materiaalstromen.",
    image: IMAGES.conveyor,
    alt: "Opslag en verwerking van kunststof materiaalstromen",
    area: "Opslagvak",
    type: "Kunststof",
  },
  {
    id: "metaal-autodemontage",
    title: "Metaal- en autodemontage",
    text: "Bewaking van materiaalhopen, voertuigen, machines en locaties waar accu's of batterijen aanwezig kunnen zijn.",
    image: IMAGES.metal,
    alt: "Metaalrecyclingterrein met schroothopen en grijpkraan",
    area: "Materiaalhoop",
    type: "Metaal",
  },
  {
    id: "batterij-elektronica",
    title: "Batterij- en elektronicarecycling",
    text: "Gerichte thermische bewaking van opslag-, sorteer- en laadgebieden met een verhoogd risico op warmteontwikkeling.",
    image: IMAGES.battery,
    alt: "Opslag van batterijen en elektronica voor recycling",
    area: "Batterijopslag",
    type: "Batterijen en accu's",
  },
  {
    id: "transportbanden",
    title: "Transportbanden en sorteerlijnen",
    text: "Bewaking van lagers, motoren, aandrijvingen en materiaal op transportbanden.",
    image: IMAGES.conveyor,
    alt: "Transportband met materiaal in een sorteerinstallatie",
    area: "Transportband",
  },
  {
    id: "hout-biomassa",
    title: "Hout- en biomassarecycling",
    text: "Monitoring van opslagvakken en materiaalhopen op afwijkende warmtepatronen.",
    image: IMAGES.wood,
    alt: "Houtsnippers en biomassa opslag op een recyclingterrein",
    area: "Materiaalhoop",
    type: "Hout",
  },
  {
    id: "buitenopslag",
    title: "Buitenopslag en recyclingterreinen",
    text: "Thermische bewaking van terreinen, opslagzones en laad- en losplaatsen, afhankelijk van afstand en zichtlijnen.",
    image: IMAGES.outdoor,
    alt: "Luchtfoto van een recyclingterrein met buitenopslag",
    area: "Buitenterrein",
  },
];

export const WORK_STEPS = [
  {
    nr: "1",
    title: "Kennismaking",
    text: "We bespreken de bedrijfsactiviteiten, materiaalstromen, bestaande voorzieningen en belangrijkste risicogebieden.",
  },
  {
    nr: "2",
    title: "Locatieanalyse",
    text: "We bekijken zichtlijnen, afstanden, opslaghoogtes, montagepunten, netwerkvoorzieningen en mogelijke omgevingsinvloeden.",
  },
  {
    nr: "3",
    title: "Ontwerp en cameraplan",
    text: "We bepalen het geschikte cameratype, de lens, montagehoogte, detectiezones en benodigde infrastructuur.",
  },
  {
    nr: "4",
    title: "Alarm- en opvolgingsplan",
    text: "We leggen vast welke temperatuurgebeurtenissen een vooralarm of alarm veroorzaken en wie daarop moet reageren.",
  },
  {
    nr: "5",
    title: "Installatie en configuratie",
    text: "De camera's, netwerkcomponenten, opnameapparatuur en mogelijke alarmkoppelingen worden geïnstalleerd en ingesteld.",
  },
  {
    nr: "6",
    title: "Testen, instructie en onderhoud",
    text: "Het systeem wordt getest. Gebruikers ontvangen uitleg over meldingen, verificatie en opvolging. Periodiek onderhoud en controle kunnen als aanvullende dienstverlening worden aangeboden.",
  },
];

export const BENEFITS = [
  "Vroegtijdige signalering van temperatuurafwijkingen",
  "Automatische bewaking van vooraf ingestelde zones",
  "Thermische controle bij dag, nacht en beperkte verlichting",
  "Snellere visuele beoordeling van een mogelijke hotspot",
  "Mogelijke integratie met bestaande bedrijfsprocessen",
  "Schaalbaar van één risicogebied tot meerdere locaties",
];

export const RELIABILITY_CHECKLIST = [
  "Vrije zichtlijn naar het meetgebied",
  "Juiste lens en detectieafstand",
  "Correct ingestelde temperatuurzones",
  "Uitsluiting van bekende warmtebronnen",
  "Getest alarm- en opvolgingsprotocol",
  "Periodieke controle en reiniging",
  "Evaluatie na veranderingen op het terrein",
];

export const FAQS = [
  {
    q: "Wat ziet een thermische camera?",
    a: "Een thermische camera registreert infrarode straling en maakt temperatuurverschillen zichtbaar. Het systeem bewaakt oppervlaktetemperaturen en warmtepatronen binnen het ingestelde camerabeeld.",
  },
  {
    q: "Kan een thermische camera een brand eerder detecteren?",
    a: "Een correct ontworpen systeem kan afwijkende warmteontwikkeling of hotspots signaleren voordat rook of vlammen zichtbaar zijn. De prestaties zijn afhankelijk van de toepassing, zichtlijn, afstand, instellingen en omgevingsfactoren.",
  },
  {
    q: "Kan het systeem ook rook detecteren?",
    a: "Ja. Afhankelijk van het cameramodel en de configuratie kan het systeem rookontwikkeling al in een vroeg stadium detecteren — vaak nog voordat er duidelijke hitte, vlammen of een meetbare temperatuurstijging ontstaat. Rookdetectie vormt zo een extra vroege waarschuwingslaag naast de thermische bewaking.",
  },
  {
    q: "Werkt het systeem ook in het donker?",
    a: "Thermische beeldvorming is niet afhankelijk van normaal zichtbaar licht. Daardoor kunnen warmtepatronen zowel overdag als 's nachts worden bewaakt.",
  },
  {
    q: "Kan de camera in een afvalhoop kijken?",
    a: "Nee. Een thermische camera bewaakt de oppervlakken die binnen de zichtlijn van de camera liggen. De camera kijkt niet door materiaal heen. De montagepositie en verdeling van camera's zijn daarom belangrijk.",
  },
  {
    q: "Kunnen verschillende alarmgrenzen worden ingesteld?",
    a: "Afhankelijk van het cameramodel en de configuratie kunnen meetgebieden, temperatuurgrenzen, vooralarmeringen en alarmacties worden ingesteld.",
  },
  {
    q: "Wat gebeurt er na een temperatuurmelding?",
    a: "Dat wordt vooraf vastgelegd in het alarm- en opvolgingsplan. Een melding kan bijvoorbeeld naar een controlekamer, videomanagementsysteem, mobiele gebruiker, alarmuitgang of externe opvolgingsdienst worden gestuurd.",
  },
  {
    q: "Vervangt een thermische camera een brandmeldinstallatie?",
    a: "Niet automatisch. Thermische cameradetectie wordt vaak gebruikt als aanvullende vroegtijdige detectie. De formele eisen verschillen per locatie, gebruiksfunctie, verzekeraar en toepasselijke regelgeving.",
  },
  {
    q: "Hoeveel camera's zijn nodig?",
    a: "Dit hangt af van de afmetingen van het terrein, de opslaghoogtes, afstanden, zichtlijnen, lenskeuze en het aantal afzonderlijke risicogebieden. Daarom voeren we eerst een locatieanalyse uit.",
  },
  {
    q: "Kan het systeem worden gekoppeld aan bestaande camera's of een controlekamer?",
    a: "Dat is in veel situaties mogelijk, maar moet technisch worden onderzocht. Beschikbare integraties verschillen per apparaat, softwareplatform en bestaande installatie.",
  },
  {
    q: "Hoe worden onnodige meldingen beperkt?",
    a: "Door zones, grenswaarden, uitsluitingsgebieden en tijdschema's zorgvuldig in te stellen. Na installatie moet het systeem onder werkelijke omstandigheden worden getest en waar nodig worden bijgesteld.",
  },
  {
    q: "Heeft een thermische camera onderhoud nodig?",
    a: "Ja. Denk aan het reinigen van de lens, het testen van meldingen, het controleren van instellingen, netwerkverbindingen, voeding en eventuele alarmuitgangen.",
  },
  {
    q: "Wat kost een thermisch camerasysteem?",
    a: "De kosten zijn afhankelijk van het aantal risicogebieden, cameratype, afstand, infrastructuur, opname, software en gewenste alarmopvolging. Na een locatieanalyse ontvangt de klant een gespecificeerd voorstel.",
  },
];

export const COMPANY_TYPES = [
  "Metaal", "Papier en karton", "Kunststof", "Rubber", "Hout", "Textiel",
  "Elektronica", "Batterijen en accu's", "Huishoudelijk afval",
  "Bouw- en sloopafval", "Biomassa", "Anders, namelijk",
];

export const AREA_OPTIONS = [
  "Afvalbunker", "Opslagvak", "Materiaalhoop", "Sorteerlijn", "Transportband",
  "Machine of installatie", "Batterijopslag", "Laad- en loszone",
  "Binnenruimte", "Buitenterrein", "Anders",
];

export const UPLOAD_CATEGORIES = [
  { key: "plattegrond", label: "Plattegrond" },
  { key: "situatietekening", label: "Situatietekening" },
  { key: "fotos", label: "Foto's van de locatie" },
  { key: "cameraplan", label: "Bestaand cameraplan" },
  { key: "risicoanalyse", label: "Risicoanalyse" },
];

export const SEO_SECTIONS = [
  {
    id: "metaalrecycling",
    title: "Thermische branddetectie voor metaalrecycling",
    text: "Bij metaalrecycling en autodemontage kunnen beschadigde accu's, oliehoudende onderdelen en frictie in machines onzichtbare warmteontwikkeling veroorzaken. Een thermische camera bewaakt schroothopen, sorteerzones en demontagelijnen op afwijkende oppervlaktetemperaturen, zodat een mogelijke hotspot eerder inzichtelijk wordt. Warmtedetectie voor het recyclingbedrijf wordt per locatie ontworpen op basis van afstand, zichtlijnen en materiaalstromen.",
  },
  {
    id: "papierrecycling",
    title: "Hotspotdetectie bij papier- en kartonrecycling",
    text: "Grote balen papier en karton vormen een aanzienlijke vuurlast. Broei en warmteontwikkeling tussen balen zijn met het blote oog vaak niet waarneembaar. Thermische bewaking van opslagvakken en buitenopslag kan afwijkende temperatuurstijgingen aan het oppervlak vroeg signaleren, zodat medewerkers de situatie kunnen controleren voordat deze escaleert.",
  },
  {
    id: "kunststofrecycling",
    title: "Thermische camera's voor kunststofrecycling",
    text: "Kunststoffen en rubber smelten en ontbranden bij oplopende temperaturen en kunnen bij brand veel rook produceren. Vroegtijdige branddetectie in de kunststofrecycling richt zich op opslagzones, shredders en productiegebieden. Instelbare temperatuurzones en vooralarmen geven eerder inzicht in mogelijke hotspots binnen het camerabeeld.",
  },
  {
    id: "batterijrecycling",
    title: "Branddetectie voor batterijopslag en elektronicarecycling",
    text: "Beschadigde lithium-ion batterijen vormen een bekend risico binnen de recyclingsector. Gerichte thermische bewaking van batterijopslag, sorteer- en laadgebieden kan afwijkende warmteontwikkeling aan het oppervlak vroeg herkennen. De detectiemogelijkheden zijn afhankelijk van de opstelling, afstand en configuratie en worden per locatie beoordeeld.",
  },
  {
    id: "afvalbunkers-seo",
    title: "Thermische bewaking van afvalbunkers",
    text: "In afvalbunkers en stortvakken wordt materiaal langere tijd opgeslagen, waardoor broei kan ontstaan. Een thermische camera boven de bunker bewaakt het zichtbare oppervlak continu op temperatuurafwijkingen en kan bij een overschrijding van de ingestelde grenswaarde een vooralarm of alarm activeren, afhankelijk van de configuratie.",
  },
  {
    id: "transportbanden-seo",
    title: "Temperatuurdetectie op transportbanden",
    text: "Lagers, motoren en aandrijvingen van transportbanden kunnen door slijtage of frictie oververhit raken. Ook kan heet of smeulend materiaal via een transportband een installatie binnenkomen. Temperatuurdetectie op transportbanden en sorteerlijnen helpt afwijkende warmtepatronen eerder te herkennen binnen het ingestelde meetgebied.",
  },
  {
    id: "buitenopslag-seo",
    title: "Thermische bewaking van buitenopslag",
    text: "Materiaalhopen op buitenterreinen zijn blootgesteld aan weersinvloeden en zijn 's nachts beperkt zichtbaar. Thermische beeldvorming is niet afhankelijk van zichtbaar licht en kan warmtepatronen op terreinen, opslagzones en laad- en losplaatsen bewaken. Bereik en nauwkeurigheid zijn afhankelijk van afstand, lenskeuze en zichtlijnen.",
  },
];
